const CommunityTotalImpactWidget = () => import('@/components/widgets/CommunityTotalImpactWidget')
const MainWidget = () => import('@/components/widgets/MainWidget')
const CompanyTotalImpactWidget = () => import('@/components/widgets/CompanyTotalImpactWidget')
const CompanyTotalImpactHiveWidget = () => import('@/components/widgets/CompanyTotalImpactHiveWidget')
const UserTotalImpactWidget = () => import('@/components/widgets/UserTotalImpactWidget')
const TestWidget = () => import('@/components/widgets/TestWidget')
const UserLogin = () => import('@/components/Login')
const CampaignWidget = () => import('@/components/widgets/CampaignProjectsWidget')
const CampaignWidgetNew = () => import('@/components/widgets/CampaignProjectsWidgetNew')
const CampaignWidgetSharedLink = () => import('@/components/widgets/CampaignProjectsWidgetSharedLink')
const EngagementWidgetSharedLink = () => import('@/components/widgets/EngagementProjectsWidgetShareLink')
const StoryWidget = () => import('@/components/widgets/StoryWidget/StoryWidget')
const ImpactGoalWidget = () => import('@/components/widgets/ImpactGoalWidget')
const EngagementWidget = () => import('@/components/widgets/EngagementProjectsWidget')
const ShareStory = () => import('@/components/widgets/ShareStory')
const AutomateStoryThankYou = () => import('@/components/widgets/AutomateStoryThankYou')
// const PublicTwitterShare = () => import('@/components/widgets/TwitterShareWidget')

export default [
  {
    path: '/frontgivingwidget/b1g1widget/:id*',
    name: 'community-widget-raw',
    components: {
      widgets: CommunityTotalImpactWidget
    }
  },
  {
    path: '/frontgivingwidget/mywidget/:key*',
    name: 'main-widget-raw',
    components: {
      widgets: MainWidget
    }
  },
  {
    path: '/frontgivingwidget/mytotalimpactwidget/:id*',
    name: 'company-total-impact-widget-raw',
    components: {
      widgets: CompanyTotalImpactWidget
    }
  },
  {
    path: '/frontgivingwidget/mytotalimpacthivewidget/:id/:user',
    name: 'company-total-impact-hive-widget-raw',
    components: {
      widgets: CompanyTotalImpactHiveWidget
    }
  },
  {
    path: '/frontgivingwidget/myleverageimpactwidget/:id*',
    name: 'user-total-impact-widget-raw',
    components: {
      widgets: UserTotalImpactWidget
    }
  },
  {
    path: '/frontgivingwidget/testwidget/:id*',
    name: 'test-widget-raw',
    components: {
      widgets: TestWidget
    }
  },
  {
    path: '/login',
    name: 'login',
    components: {
      widgets: UserLogin
    }
  },
  {
    path: '/campaign/campaigndata/:key*',
    name: 'campaign-widget-raw',
    components: {
      widgets: CampaignWidget
    }
  },
  {
    path: '/campaign/campaigndata-new/:key*',
    name: 'campaign-new-widget-raw',
    components: {
      widgets: CampaignWidgetNew
    }
  },
  {
    path: '/campaign/shared/:key*',
    name: 'campaign-shared-link-widget-raw',
    components: {
      widgets: CampaignWidgetSharedLink
    }
  },
  {
    path: '/campaign/storyembedded/:id*',
    name: 'story-widget-raw',
    components: {
      widgets: StoryWidget
    }
  },
  {
    path: '/frontgivingwidget/myimpactgoalwidget/:id*',
    name: 'impact-goal-widget-raw',
    components: {
      widgets: ImpactGoalWidget
    }
  },
  // Engagement widgets
  {
    path: '/engagement/engagementdata/:key*',
    name: 'engagement-widget-raw',
    components: {
      widgets: EngagementWidget
    }
  },
  {
    path: '/engagement/shared/:key*',
    name: 'engagement-shared-link-widget-raw',
    components: {
      widgets: EngagementWidgetSharedLink
    }
  },
  {
    path: '/thankyou/:key',
    // name: 'automated-story-shared-link',
    components: {
      widgets: ShareStory
    },
    meta: (route) => ({title: 'Story Shared Link'})
  },
  {
    path: '/thankyou',
    components: {
      widgets: AutomateStoryThankYou
    },
    meta: (route) => ({title: 'Thank you'})
  }
  // {
  //   path: '/share-in-twitter/:id',
  //   name: 'share-in-twitter-widget-raw',
  //   components: {
  //     widgets: PublicTwitterShare
  //   }
  // }
]



// WEBPACK FOOTER //
// ./src/router/widget.js